import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { getData, postData } from "../components/helpers/Data";
import { Spinner } from "../components/helpers/Spinner";
import MessageModal from "../components/helpers/Modal2";
import ResponseModal from "../components/helpers/Modal2";
import Modal5 from "../components/helpers/Modal5";
import { userSaveDetails } from "../components/helpers/UserSaveDetails";
import { Link } from "react-router-dom";
import Select from "react-select";
import Select2 from "react-select2-wrapper";
import "react-select2-wrapper/css/select2.css";
import $ from "jquery";
import { CurrencyCommaRemoval } from "../components/helpers/CurrencyCommaRemoval";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import { today3 } from "../components/helpers/today";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ReactDom from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Layout from "../components/layout/Layout_final";
import App from "../App";
import Login from "./login/Login";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const SalesMain = () => {
  //create array for logs when renewing corp
  const logData = userSaveDetails(1);

  // $(function () {
  //   $("#items").select2();
  // });

  //module variables
  const fullscreenRef = useRef(null);
  const [itemsData, setItemsData] = useState({ all: [], filtered: [] });
  const [clinicalDiagnosis, setClinicalDiagnosis] = useState({
    all: [],
    filtered: [],
  });
  const [transactionType, setTransactionType] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [appendedDrug, setAppendedDrug] = useState([]);
  const [messageModal, setMessageModal] = useState(false);
  const [tableModal, setIsTableModal] = useState(false);
  const [responseModal, setResponseModal] = useState(false);
  const [response, setResponse] = useState(false);
  const [message, setMessage] = useState(false);
  const [selectedTransType, setSelectedTransType] = useState("0");
  const [totals, setTotals] = useState(0);
  const [amountPaid, setAmountPaid] = useState(0);
  const [balance, setBalance] = useState(0);
  const [paid, setPaid] = useState(0);
  const [hidden, setHidden] = useState(true);
  const [rowMaxes, setRowMaxes] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedClinicalDiagnosisOption, setSelectedClinicalDiagnosisOption] =
    useState(null);
  const [patientData, setPatientData] = useState([]);
  const [reservedData, setReservedData] = useState([]);
  const [choosenClinicalDiagnosis, setChoosenClinicalDiagnosis] = useState([]);

  const home = () => {
    ReactDom.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>,
      document.getElementById("root"),
    );
  };
  

  useEffect(() => {
    if (selectedTransType == 2) {
      setHidden(false);
    } else {
      setHidden(true);
      document.getElementById("mpesa_code").value = "";
    }
  }, [selectedTransType]);

  useEffect(() => {
    getData("fetch_stock_for_sales")
      .then((data) => {
        const datum = data
          // .filter((dt) => dt.retail_price !== 0)
          .map((dt) => ({
            value: dt.id,
            label: dt.item_full_details,
            code: dt.item_code,
            items: dt.item_full_details,
            item_less_details: dt.item_less_details,
            names: dt.name + " - " + dt.category,
            expiry_date: dt.expiry_date,
            price: dt.retail_price_per_item,
            quantity_available: dt.quantity_available,
            quantity_stocked: dt.quantity_stocked,
            stock_id: dt.id,
          }));

        setItemsData({ all: datum, filtered: datum });
      })
      .catch((error) => {
        console.log(error);
      });

    getData("fetch_transaction_type")
      .then((data) => {
        setTransactionType(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    handleSearch(selectedOption.value);
  };

  const handleClinicalDiagnosisChange = (selectedOption) => {
    setSelectedClinicalDiagnosisOption(selectedOption);
  };
  // ✅ NEW: determine the active (oldest available) batch per item
  const getActiveBatch = (items, itemCode) => {
    const sameItems = items
      .filter((i) => i.code === itemCode && i.quantity_available > 0)
      .sort((a, b) => {
        if (!a.expiry_date) return 1;
        if (!b.expiry_date) return -1;
        return new Date(a.expiry_date) - new Date(b.expiry_date);
      });

    return sameItems[0]; // oldest valid batch
  };

  const handleChange2 = (selectedOption) => {
    if (!selectedOption) return;

    // ✅ NEW: force selection to always pick the correct batch
    const itemCode = selectedOption.code;
    const bestOption = getActiveBatch(itemsData.all, itemCode);

    if (!bestOption) {
      setMessage("Item out of stock");
      setMessageModal(true);
      return;
    }

    setSelectedOption(bestOption); // ✅ CHANGED: use bestOption instead of selectedOption
    handleSearch(bestOption.value); // ✅ CHANGED
  };

  const handleSearch2 = (searchQuery) => {
    //filter items
    const filteredData = itemsData.all.filter(
      (item) =>
        item.value !== null &&
        item.value.toString().toLowerCase() ===
          searchQuery.toString().toLowerCase(),
    );

    // Select all rows inside the tbody
    let rows = document.querySelectorAll("#drug_tbl tbody tr");
    let firstColumnData = [];
    rows.forEach((row) => {
      let firstCell = row.querySelector("td");
      if (firstCell) {
        let input = firstCell.querySelector("input");
        if (input) {
          firstColumnData.push(input.value.trim());
        }
      }
    });

    //append row to table if stock is available
    if (filteredData[0].price != 0) {
      if (!firstColumnData.includes(String(filteredData[0].stock_id))) {
        const newRowId = new Date().getTime().toString();
        const row = {
          id: newRowId,
          new: (
            <>
              <td>
                <input
                  name="id[]"
                  value={filteredData[0].stock_id}
                  className="form-control"
                  style={{ width: "50px" }}
                  readOnly
                />
              </td>
              <td>
                <input
                  name="code[]"
                  value={filteredData[0].code}
                  className="form-control"
                  style={{ width: "50px" }}
                  readOnly
                />
              </td>
              <td>
                {" "}
                <input
                  name="item[]"
                  value={filteredData[0].item_less_details}
                  className="form-control"
                  style={{ width: "250px" }}
                  readOnly
                />
              </td>
              <td>
                <input
                  name="stock_id[]"
                  value={filteredData[0].stock_id}
                  className="form-control"
                  style={{ width: "50px" }}
                  readOnly
                />
              </td>
              <td>
                <input
                  name="quantity_stocked[]"
                  value={filteredData[0].quantity_stocked}
                  className="form-control"
                  style={{ width: "50px" }}
                  readOnly
                />
              </td>
              <td>
                <input
                  name="expiry_date[]"
                  value={filteredData[0].expiry_date}
                  className="form-control"
                  style={{ width: "100px" }}
                  readOnly
                />
              </td>
              <td>
                <input
                  type="number"
                  name="quantity[]"
                  className={"form-control"}
                  defaultValue="1"
                  min="1"
                  max={filteredData[0].quantity_available}
                  onChange={(e) => {
                    enforceMaxInput(e, filteredData[0].quantity_available);
                    calculateRowTotal(e);
                  }}
                />
              </td>
              <td>
                <input
                  type="text"
                  name="price[]"
                  value={filteredData[0].price}
                  className={"form-control"}
                  defaultValue="0"
                  readOnly
                />
              </td>

              <td>
                <input
                  type="text"
                  value={filteredData[0].price}
                  name="total[]"
                  defaultValue="0"
                  className={"form-control"}
                  style={{ width: "100px" }}
                  readOnly
                />
              </td>
              <td>
                <button
                  type="button"
                  className="btn text-danger btn-sm"
                  onClick={() => removeDrug(row.id)}
                >
                  <i className="fas fa-trash fa-sm"></i>
                </button>
              </td>
            </>
          ),
        };

        setAppendedDrug((appendedDrug) => {
          return [...appendedDrug, row];
        });

        calculateAllTotals();
      } else {
        setMessage(`${filteredData[0].items} already exists in sales table!`);
        setMessageModal(true);
      }
    } else {
      setMessage(`Add stock for ${filteredData[0].items} !`);
      setMessageModal(true);
    }
  };
  const handleSearch = (searchQuery) => {
    const filteredData = itemsData.all.filter(
      (item) =>
        item.value !== null &&
        item.value.toString().toLowerCase() ===
          searchQuery.toString().toLowerCase(),
    );

    if (filteredData.length === 0) {
      setMessage("Item not found");
      setMessageModal(true);
      return;
    }

    const selectedItem = filteredData[0];

    if (selectedItem.price === 0) {
      setMessage(`Add stock for ${selectedItem.items}!`);
      setMessageModal(true);
      return;
    }

    const requestedQty = 1;
    const frmData = new FormData();
    frmData.append("stock_id", selectedItem.stock_id);
    frmData.append("quantity", requestedQty);
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );

    postData(frmData, "fetch_reserved_stock")
      .then((data) => {
        if (!data.success) {
          setMessage(`Only ${data.available} units left`);
          setMessageModal(true);
          return;
        }

        // ⚡ Use the actual batch stock_id returned by backend
        const actualStockId = data.stock_id;

        // ✅ Check duplicates AFTER backend determines the real batch
        const batchAlreadyAdded = appendedDrug.some(
          (row) => row.stockId === actualStockId,
        );
        if (batchAlreadyAdded) {
          setMessage(`${selectedItem.items} batch already added!`);
          setMessageModal(true);
          return;
        }

        const stockData = data.stock || selectedItem;

        const newRow = {
          id: new Date().getTime().toString(),
          quantity: requestedQty,
          stockId: actualStockId,
          stock: stockData,
        };

        setAppendedDrug((prev) => [...prev, newRow]);
        calculateAllTotals();
      })
      .catch((error) => {
        console.log(error);
        setMessage("Error reserving stock!");
        setMessageModal(true);
      });
  };
  const handleSearch5 = (searchQuery) => {
    const filteredData = itemsData.all.filter(
      (item) =>
        item.value !== null &&
        item.value.toString().toLowerCase() ===
          searchQuery.toString().toLowerCase(),
    );

    const selectedItem = filteredData[0];

    if (filteredData.length === 0) {
      setMessage("Item not found");
      setMessageModal(true);
      return;
    }

    let rows = document.querySelectorAll("#drug_tbl tbody tr");
    let firstColumnData = [];
    rows.forEach((row) => {
      let firstCell = row.querySelector("td");
      if (firstCell) {
        let input = firstCell.querySelector("input");
        if (input) {
          firstColumnData.push(input.value.trim());
        }
      }
    });

    if (firstColumnData.includes(String(selectedItem.stock_id))) {
      setMessage(`${selectedItem.items} already exists in sales table!`);
      setMessageModal(true);
      return;
    }

    if (selectedItem.price === 0) {
      setMessage(`Add stock for ${selectedItem.items}!`);
      setMessageModal(true);
      return;
    }

    const requestedQty = 1;
    const frmData = new FormData();
    frmData.append("stock_id", selectedItem.stock_id);
    frmData.append("quantity", requestedQty);
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );

    postData(frmData, "fetch_reserved_stock")
      .then((data) => {
        if (!data.success) {
          setMessage(`Only ${data.available} units left`);
          setMessageModal(true);
          return;
        }

        // ⚠️ Use backend's actual reserved stock ID
        const actualStockId = data.stock_id;

        // ✅ Check if this exact batch is already appended
        const batchAlreadyAdded = appendedDrug.some(
          (row) => row.stockId === actualStockId,
        );
        if (batchAlreadyAdded) {
          setMessage(`Batch for ${selectedItem.items} already added!`);
          setMessageModal(true);
          return;
        }

        const stockData = data.stock || selectedItem;

        const newRow = {
          id: new Date().getTime().toString(),
          quantity: requestedQty,
          stockId: actualStockId,
          stock: stockData,
        };

        setAppendedDrug((prev) => [...prev, newRow]);
        calculateAllTotals();
      })
      .catch((error) => {
        console.log(error);
        setMessage("Error reserving stock!");
        setMessageModal(true);
      });
  };

  const handleSearch3 = (searchQuery) => {
    //filter items
    const filteredData = itemsData.all.filter(
      (item) =>
        item.value !== null &&
        item.value.toString().toLowerCase() ===
          searchQuery.toString().toLowerCase(),
    );

    if (filteredData.length === 0) {
      setMessage("Item not found");
      setMessageModal(true);
      return;
    }

    // Select all rows inside the tbody
    let rows = document.querySelectorAll("#drug_tbl tbody tr");
    let firstColumnData = [];
    rows.forEach((row) => {
      let firstCell = row.querySelector("td");
      if (firstCell) {
        let input = firstCell.querySelector("input");
        if (input) {
          firstColumnData.push(input.value.trim());
        }
      }
    });

    const selectedItem = filteredData[0];

    if (selectedItem.price === 0) {
      setMessage(`Add stock for ${selectedItem.items} !`);
      setMessageModal(true);
      return;
    }

    if (firstColumnData.includes(String(selectedItem.stock_id))) {
      setMessage(`${selectedItem.items} already exists in sales table!`);
      setMessageModal(true);
      return;
    }

    // ✅ NEW: Reserve stock from backend before adding row
    const requestedQty = 1; // you can change this if user selects more than 1 initially
    const frmData = new FormData();
    frmData.append("stock_id", selectedItem.stock_id);
    frmData.append("quantity", requestedQty);
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );
    postData(frmData, "fetch_reserved_stock")
      .then((data) => {
        console.log(data);

        if (!data.success) {
          setMessage(`Only ${data.available} units left`);
          setMessageModal(true);
          return;
        }

        if (data.switched) {
          setMessage("Switched to next available batch");
          setMessageModal(true);
        }

        // Use backend stock if available, fallback to selectedItem
        const stockData = data.stock || selectedItem;

        // Track row ID and quantity
        const newRowId = new Date().getTime().toString();
        const newRow = {
          id: newRowId,
          quantity: requestedQty,
          stockId: data.stock_id,
          stock: stockData,
        };

        // Add to state
        setAppendedDrug((prev) => [...prev, newRow]);
        calculateAllTotals();
      })
      .catch((error) => {
        setMessage("Error reserving stock!");
        setMessageModal(true);
        console.log(error);
      });
    // postData(frmData, "fetch_reserved_stock")
    //   .then((data) => {
    //     console.log(data);

    //     if (!data.success) {
    //       setMessage(`Only ${data.available} units left`);
    //       setMessageModal(true);
    //       return;
    //     }

    //     if (data.switched) {
    //       setMessage("Switched to next available batch");
    //       setMessageModal(true);
    //     }

    //     // -------------------------
    //     // 1️⃣ Define stockData for display
    //     // -------------------------
    //     const stockData = data.stock || selectedItem;

    //     // -------------------------
    //     // 2️⃣ Track current quantity and stock for updates
    //     // -------------------------
    //     let currentQty = requestedQty;
    //     let currentStockId = data.stock_id;

    //     // -------------------------
    //     // 3️⃣ Create the row using stockData
    //     // -------------------------
    //     const newRowId = new Date().getTime().toString();
    //     const row = {
    //       id: newRowId,
    //       new: (
    //         <>
    //           <td>
    //             <input
    //               name="id[]"
    //               value={currentStockId} // confirmed by backend
    //               className="form-control"
    //               style={{ width: "50px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               name="code[]"
    //               value={stockData.code}
    //               className="form-control"
    //               style={{ width: "50px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               name="item[]"
    //               value={stockData.item_less_details}
    //               className="form-control"
    //               style={{ width: "250px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               name="stock_id[]"
    //               value={currentStockId}
    //               className="form-control"
    //               style={{ width: "50px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               name="quantity_stocked[]"
    //               value={stockData.quantity_available}
    //               className="form-control"
    //               style={{ width: "50px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               name="expiry_date[]"
    //               value={stockData.expiry_date}
    //               className="form-control"
    //               style={{ width: "100px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               type="number"
    //               name="quantity[]"
    //               className="form-control"
    //               defaultValue={requestedQty}
    //               min="1"
    //               max={
    //                 rowMaxes[currentStockId] || data.available + requestedQty
    //               }
    //               onChange={(e) => {
    //                 let newQty = parseInt(e.target.value) || 1;

    //                 if (e.target.debounceTimeout)
    //                   clearTimeout(e.target.debounceTimeout);

    //                 e.target.debounceTimeout = setTimeout(() => {
    //                   const frmData = new FormData();
    //                   frmData.append("stock_id", currentStockId); // ✅ use currentStockId
    //                   frmData.append("quantity", newQty);
    //                   frmData.append("type", "set");
    //                   frmData.append(
    //                     "session_id",
    //                     sessionStorage.getItem("mwerezi_mpos_sessionId"),
    //                   );

    //                   postData(frmData, "update_reservation")
    //                     .then((res) => {
    //                       if (!res.success) {
    //                         e.target.value = currentQty;
    //                         setMessage(`Only ${res.available} units left`);
    //                         setMessageModal(true);
    //                         return;
    //                       }

    //                       currentQty = newQty;

    //                       // ✅ if backend switched batch during update
    //                       if (res.switched) {
    //                         currentStockId = res.stock_id;
    //                         // Optional: update UI fields manually if needed
    //                       }

    //                       setRowMaxes((prev) => ({
    //                         ...prev,
    //                         [currentStockId]: res.available + newQty,
    //                       }));

    //                       calculateRowTotal(e);
    //                     })
    //                     .catch((err) => {
    //                       console.log(err);
    //                       e.target.value = currentQty;
    //                       setMessage("Error updating quantity");
    //                       setMessageModal(true);
    //                     });
    //                 }, 300);
    //               }}
    //             />
    //           </td>
    //           <td>
    //             <input
    //               type="text"
    //               name="price[]"
    //               value={stockData.price}
    //               className="form-control"
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <input
    //               type="text"
    //               value={stockData.price}
    //               name="total[]"
    //               className="form-control"
    //               style={{ width: "100px" }}
    //               readOnly
    //             />
    //           </td>
    //           <td>
    //             <button
    //               type="button"
    //               className="btn text-danger btn-sm"
    //               onClick={() => removeDrug(row.id)}
    //             >
    //               <i className="fas fa-trash fa-sm"></i>
    //             </button>
    //           </td>
    //         </>
    //       ),
    //     };

    //     setAppendedDrug((appendedDrug) => [...appendedDrug, row]);
    //     calculateAllTotals();
    //   })
    //   .catch((error) => {
    //     setMessage("Error reserving stock!");
    //     setMessageModal(true);
    //     console.log(error);
    //   });
  };

  // ✅ Only show the active batch per item
  // const filteredDropdownOptions = itemsData.all.filter((item) => {
  //   const activeBatch = getActiveBatch(itemsData.all, item.code);
  //   return activeBatch && activeBatch.stock_id === item.stock_id;
  // });

  // useEffect(() => {
  //   alert(selectedOption);
  // }, [selectedOption]);

  // useEffect(() => {
  //  const newRowId = new Date().getTime().toString();
  //  const row = {
  //    id: newRowId,
  //    new: (
  //      <>
  //        <td>
  //          <input
  //            id={newRowId + "input"}
  //            list="drug_search"
  //            className="form-control"
  //            style={{ width: "100%" }}
  //            onInput={handleSearch}
  //            onKeyDown={(e) =>
  //              e.key === "Enter"
  //                ? appendDrugRow(e)
  //                : e.key === "Delete"
  //                ? removeDrug(row.id)
  //                : null
  //            }
  //          />
  //          <datalist id="drug_search">
  //            {itemsData.all.map((dt) => {
  //              return (
  //                <option key={dt.code} value={dt.items}>
  //                  {dt.code}
  //                </option>
  //              );
  //            })}
  //          </datalist>
  //        </td>
  //        <td>
  //          <input
  //            name="code[]"
  //            className="form-control"
  //            style={{ width: "50px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          {" "}
  //          <input
  //            name="drug[]"
  //            className="form-control"
  //            style={{ width: "300px" }}
  //            readOnlyfetchState
  //          />
  //        </td>
  //        <td>
  //          <input
  //            name="stock_id[]"
  //            className="form-control"
  //            style={{ width: "50px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <input
  //            name="expiry_date[]"
  //            className="form-control"
  //            style={{ width: "100px" }}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <input
  //            type="number"
  //            name="quantity[]"
  //            className={"form-control"}
  //            defaultValue="1"
  //            min="1"
  //            onChange={calculateRowTotal}
  //          />
  //        </td>
  //        <td>null
  //            name="price[]"
  //            className={"form-control"}
  //            defaultValue="0"
  //            readOnly
  //          />
  //        </td>

  //        <td>
  //          <input
  //            type="text"
  //            name="total[]"
  //            defaultValue="0"
  //            className={"form-control"}
  //            readOnly
  //          />
  //        </td>
  //        <td>
  //          <button
  //            type="button"
  //            className="btn text-danger btn-sm"
  //            onClick={() => removeDrug(row.id)}
  //          >
  //            <i className="fas fa-trash fa-sm"></i>
  //          </button>
  //        </td>
  //      </>
  //    ),
  //  };

  //  setAppendedDrug((appendedDrug) => {
  //    return [...appendedDrug, row];
  //  });

  //  // Focus on the new row's input element
  //  setTimeout(() => {
  //    //   const newRowInput = document.querySelector(`#${row.id} input`);
  //    const newRowInput = document.getElementById(`${row.id}input`);
  //    console.log(row.id);
  //    if (newRowInput) {
  //      newRowInput.focus();
  //    }
  //  }, 100);
  // }, [])

  // append drug

  //remove bank row
  const removeDrug = async (id) => {
    const row = appendedDrug.find((r) => r.id === id);
    if (!row) return;

    // Prepare FormData to set quantity to 0
    const frmData = new FormData();
    frmData.append("stock_id", row.stockId);
    frmData.append("quantity", 0); // signal delete
    frmData.append("type", "set");
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );

    try {
      const res = await postData(frmData, "update_reservation");
      if (!res.success) {
        setMessage("Error removing reserved stock from server");
        setMessageModal(true);
        return;
      }

      // Now remove the row from frontend
      setAppendedDrug((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.log(err);
      setMessage("Error removing reserved stock");
      setMessageModal(true);
    }
  };
  const removeDrug2 = async (id) => {
    // e.preventDefault();
    setAppendedDrug((appendedDrug) => {
      return appendedDrug.filter((row) => row.id !== id);
    });
  };

  useEffect(() => {
    calculateAllTotals();
  }, [appendedDrug]);

  const enforceMaxInput = (e, val) => {
    const max = parseInt(val, 10);
    const min = 1;
    let value = parseInt(e.target.value, 10);

    // Prevent invalid or empty inputs
    if (isNaN(value)) value = min;

    // Clamp the value between min and max
    if (value > max) value = max;
    if (value < min) value = min;

    e.target.value = value; // Update input value
  };

  const calculateRowTotal = (e) => {
    const price = CurrencyCommaRemoval(
      e.target.closest("tr").children[7].children[0].value,
    );
    let total = parseFloat(price) * parseFloat(e.target.value);
    e.target.closest("tr").children[7].children[0].value =
      total.toLocaleString();
    calculateAllTotals();
  };
  const calculateAllTotals = () => {
    let ttl = 0;
    document.querySelectorAll("#drug_tbl tbody tr").forEach((element) => {
      ttl += parseFloat(
        CurrencyCommaRemoval(element.children[8].children[0].value),
      );
    });
    document.getElementById("totals").innerHTML = ttl.toLocaleString();
    setTotals(ttl);
  };

  const checkout = () => {
    let ttl = document.getElementById("totals").innerHTML;
    setTotals(ttl);
    setBalance(-parseFloat(ttl.replace(/,/g, "")));
    setIsTableModal(true);
  };

  //checkout summary
  const calcBalance = (e) => {
    setPaid(parseFloat(e.target.value));
    let blc = parseFloat(e.target.value) - parseFloat(totals.replace(/,/g, ""));
    blc = isNaN(blc) ? -totals : blc;
    setBalance(blc);
    setAmountPaid(e.target.value);
  };

  //search customer
  const searchPatient = () => {
    setPatientData([]);
    const mobile_no = document.getElementById("patient_phone_no").value;
    const frmData = new FormData();
    frmData.append("mobile_no", mobile_no);
    postData(frmData, "fetch_patient_with_mobile_no")
      .then((data) => {
        if (data.length !== 0) {
          setPatientData(data[0]);
        }
      })
      .catch((error) => console.log(error));
  };

  //save drug
  const saveSale = () => {
    closeTableModal();
    const frmData = new FormData(document.getElementById("sale_form"));
    frmData.append("user", localStorage.getItem("mpharma_username"));
    // frmData.append("customer_no", document.getElementById("customer_no").value);
    // frmData.append("trans_type", document.getElementById("trans_type").value);
    // frmData.append("mpesa_code", document.getElementById("mpesa_code").value);
    // frmData.append(
    //   "clinical_diagnosis",
    //   document.getElementById("clinical_diagnosis").value
    // );

    //append access log details
    frmData.append("user_id", logData[0]);
    frmData.append("accessed_item", logData[1]);
    frmData.append("browser_type", logData[2]);
    frmData.append("os_type", logData[3]);

    postData(frmData, "save_sale")
      .then((data) => {
        setResponse(data.message);
        setResponseModal(true);
        document.getElementById("spinner").display = "none";
        printPdf(data.sale_code);
      })
      .catch((error) => {
        console.log(error);
        document.getElementById("spinner").display = "none";
      });
  };

  const handleQuantityChange = (e, rowId) => {
    const newQty = parseInt(e.target.value) || 1;
    const row = appendedDrug.find((r) => r.id === rowId);

    const frmData = new FormData();
    frmData.append("stock_id", row.stockId);
    frmData.append("quantity", newQty);
    frmData.append("type", "set");
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );

    postData(frmData, "update_reservation")
      .then((res) => {
        if (!res.success) {
          e.target.value = row.quantity;
          setMessage(res.message || `Only ${res.available} units left`);
          setMessageModal(true);
          return;
        }

        // 1️⃣ Update existing row
        setAppendedDrug((prev) =>
          prev.map((r) => {
            if (r.id === rowId) {
              return {
                ...r,
                quantity: newQty - (res.newQty || 0), // remaining qty in original batch
                stock: r.stock,
                stockId: r.stockId,
              };
            }
            return r;
          }),
        );

        // 2️⃣ Add new row if batch was split
        if (res.split && res.newStock) {
          const newRowId = new Date().getTime().toString();
          const newRow = {
            id: newRowId,
            quantity: res.newQty,
            stockId: res.newStock.id,
            stock: res.newStock,
          };
          setAppendedDrug((prev) => [...prev, newRow]);
        }

        // 3️⃣ Update max per stock
        setRowMaxes((prev) => ({
          ...prev,
          [row.stockId]: res.available + (res.newQty || 0),
          [res.newStock?.id || row.stockId]: res.newStock
            ? res.newStock.quantity_available
            : undefined,
        }));

        calculateAllTotals();
      })
      .catch((err) => {
        console.log(err);
        e.target.value = row.quantity;
        setMessage("Error updating quantity");
        setMessageModal(true);
      });
  };

  const handleQuantityChange2 = (e, rowId) => {
    const newQty = parseInt(e.target.value) || 1;
    const row = appendedDrug.find((r) => r.id === rowId);

    const frmData = new FormData();
    frmData.append("stock_id", row.stockId);
    frmData.append("quantity", newQty);
    frmData.append("type", "set");
    frmData.append(
      "session_id",
      sessionStorage.getItem("mwerezi_mpos_sessionId"),
    );

    postData(frmData, "update_reservation")
      .then((res) => {
        if (!res.success) {
          e.target.value = row.quantity;
          setMessage(`Only ${res.available} units left`);
          setMessageModal(true);
          return;
        }

        // Update row data including backend-switched stock
        setAppendedDrug((prev) =>
          prev.map((r) => {
            if (r.id === rowId) {
              return {
                ...r,
                quantity: newQty,
                stock: res.stock || r.stock,
                stockId: res.stock_id || r.stockId,
              };
            }
            return r;
          }),
        );

        // Update max per stock
        setRowMaxes((prev) => ({
          ...prev,
          [res.stock_id || row.stockId]: res.available + newQty,
        }));

        calculateAllTotals();
      })
      .catch((err) => {
        console.log(err);
        e.target.value = row.quantity;
        setMessage("Error updating quantity");
        setMessageModal(true);
      });
  };

  //print
  const printPdf = (code) => {
    let totals = document.getElementById("totals").innerHTML;
    // let customer_no = document.getElementById("customer_no").value;
    // let trans_type = document.getElementById("trans_type");
    // let opts = trans_type.options[trans_type.selectedIndex].text;

    let header = `<thead><tr style="border-top:none;border-right:none;border-left:none;"><th>Item</th><th>Quantity</th><th>Price</th><th>Total</th></tr></thead>`;

    let rows = "";

    document.querySelectorAll("#drug_tbl tbody tr").forEach((element) => {
      rows += `
        <tr style="border:none;">
          <td>${element.children[2].children[0].value}</td>
          <td>${element.children[5].children[0].value}</td>
          <td>${element.children[6].children[0].value}</td>
          <td>${element.children[7].children[0].value}</td>
        </tr>
        `;
    });

    let body = `<tbody">${rows}</tbody>`;

    let footer = `<tfoot>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Total</th><th colspan="2">${totals}</th></tr>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Amount Paid</th><th colspan="2">${parseFloat(
      amountPaid,
    ).toLocaleString()}</th></tr>
    <tr style="border-bottom:none;border-right:none;border-left:none;text-align:right;"><th colspan="2">Balance</th><th colspan="2">${parseFloat(
      balance,
    ).toLocaleString()}</th></tr>
    </tfoot>`;

    let doc = `
    <div style="font-size:10px;">
    <p style="text-align:center;font-size:20px">MPOS</p>
    <p style="bottom:0;display:flex;text-align:center;">Receipt no : ${code} <span style="font-size:15px;">|</span>  Date :  ${today3()}</p>
    <br/><br/>
    <table style="width:100%;">${header}${body}${footer}</table>
    <p style="bottom:0;display:flex;text-align:center;">0742551965 <span style="font-size:15px;">|</span> mwerezi.co.ke  <span style="font-size:15px;">|</span> info@mwerezi.co.ke</p>
    </div>
    `;
    // <p style="bottom:0;display:flex;text-align:center;"> Phone : ${customer_no} <span style="font-size:15px;">|</span> Payment Mode : ${opts}</p>

    var val = htmlToPdfmake(doc);
    var dd = {
      pageOrientation: "potrait",
      pageMargins: [10, 2, 2, 2],
      content: val,
      pageSize: "A7",
    };
    pdfMake.createPdf(dd).download();
  };
  //close response modal
  const closeResponseModal = () => {
    setResponseModal(false);
    // window.location.reload();
  };
  //close message modal
  const closeMessageModal = () => {
    setMessageModal(false);
    // window.location.reload();
  };
  //table modal
  const closeTableModal = () => {
    setIsTableModal(false);
    setBalance(0);
    // window.location.reload();
  };

 const logout = () => {
    if (typeof Storage !== "undefined") {
      localStorage.removeItem("mwerezi_mpos_username");
      localStorage.removeItem("mpos_fullname");
      localStorage.removeItem("mwerezi_mpos_usergroups");
      sessionStorage.removeItem("mpos_hasReloaded");
      ReactDOM.render(<Login />, document.getElementById("root"));
    } else {
      console.log("Sorry, something went wrong, please contact admin!");
    }
  };
  return (
    <div className="m-3"> 
    <button className="btn btn-danger btn-sm" onClick={logout}>logout</button>    
        <div >
          {/* <span className="text-danger text-center fw-bolder">
                      Search Options
                    </span> */}
          <Select
            options={itemsData.all}
            // options={filteredDropdownOptions}
            isSearchable
            isClearable
            onChange={handleChange}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              menu: (base) => ({ ...base, backgroundColor: "white" }),
              option: (provided, state) => ({
                ...provided,
                color: state.isFocused ? "white" : "black",
                backgroundColor: state.isSelected
                  ? "#ddd"
                  : state.isFocused
                    ? "grey"
                    : "white",
              }),
              control: (base) => ({
                ...base,
                zIndex: 1, // ensures control stays above content
                position: "relative",
              }),
              clearIndicator: (base) => ({
                ...base,
                cursor: "pointer",
                color: "black",
                "&:hover": { color: "red" }, // optional hover effect
              }),
              singleValue: (base) => ({ ...base, color: "black" }), // ensures selected text clears properly
            }}
          />

          <div className="row">
            <div className="border-success col-md-12 p-2">
              <span className="text-danger text-center fw-bolder">
                Sale details
              </span>

              <form id="sale_form" onSubmit={saveSale}>
                <div className="col-md-12 justify-content-center">
                  <table
                    className="table table-bordered"
                    style={{ maxHeight: "500px", width: "100%" }}
                    id={"drug_tbl"}
                  >
                    <thead className="table-fixed-header">
                      <tr>
                        <th>Id</th>
                        <th>Code</th>
                        <th>items</th>
                        <th>Stock Id</th>
                        <th>Quantity Stocked</th>
                        <th>Expiry Date</th>
                        <th>Quantity</th>
                        <th>Price per Item</th>
                        <th>Total</th>
                        <th>Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {appendedDrug.map((data) => {
                        return <tr key={data.id}>{data.new}</tr>;
                      })} */}
                      {appendedDrug.map((row) => {
                        return (
                          <tr key={row.id}>
                            <td>
                              <input
                                name="id[]"
                                value={row.stockId}
                                readOnly
                                className="form-control"
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                name="code[]"
                                value={row.stock.item_code}
                                readOnly
                                className="form-control"
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                name="item[]"
                                value={row.stock.item_less_details}
                                readOnly
                                className="form-control"
                                style={{ width: "250px" }}
                              />
                            </td>
                            <td>
                              <input
                                name="stock_id[]"
                                value={row.stockId}
                                readOnly
                                className="form-control"
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                name="quantity_stocked[]"
                                value={row.stock.quantity_available}
                                readOnly
                                className="form-control"
                                style={{ width: "50px" }}
                              />
                            </td>
                            <td>
                              <input
                                name="expiry_date[]"
                                value={row.stock.expiry_date}
                                readOnly
                                className="form-control"
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                name="quantity[]"
                                value={row.quantity}
                                min="1"
                                max={
                                  rowMaxes[row.stockId] ||
                                  row.stock.quantity_available + row.quantity
                                }
                                className="form-control"
                                onChange={(e) =>
                                  handleQuantityChange(e, row.id)
                                }
                              />
                            </td>
                            <td>
                              <input
                                name="price[]"
                                value={row.stock.retail_price_per_item}
                                readOnly
                                className="form-control"
                              />
                            </td>
                            <td>
                              <input
                                name="total[]"
                                value={
                                  row.stock.retail_price_per_item * row.quantity
                                }
                                readOnly
                                className="form-control"
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn text-danger btn-sm"
                                onClick={() => removeDrug(row.id)}
                              >
                                <i className="fas fa-trash fa-sm"></i>
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <span
                            style={{
                              fontSize: "15px",
                              color: "green",
                              fontWeight: "bold",
                            }}
                          >
                            Total
                          </span>
                        </td>
                        <td>
                          <span
                            style={{
                              fontSize: "15px",
                              margin: "0px",
                              textAlign: "left",
                              color: "green",
                              fontWeight: "bolder",
                            }}
                            id="totals"
                          >
                            0
                          </span>
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                  <p>
                    <button
                      disabled={totals <= 0 ? true : false}
                      type="button"
                      className="btn btn-success btn-sm col-2 mb-1"
                      onClick={checkout}
                    >
                      Checkout
                    </button>
                  </p>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    {/* This is hidden */}
                    <div className="input-group col-md-12 mb-2 hidden">
                      <input
                        className="form-control"
                        type="text"
                        id="patient_phone_no"
                        placeholder="Patient Phone No"
                        aria-label="Patient Phone No"
                        aria-describedby="basic-addon2"
                      />
                      <div className="input-group-append col-md-3">
                        <button
                          onClick={searchPatient}
                          className="btn btn-outline-secondary btn-sm"
                          type="button"
                        >
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    {/* This is hidden */}
                    <Select
                      className="col-md-12 hidden"
                      options={clinicalDiagnosis.filtered}
                      isSearchable={true}
                      placeholder="Search clinical diagnosis..."
                      isClearable={true}
                      onChange={handleClinicalDiagnosisChange}
                    />
                  </div>
                  {/* This is hidden */}
                  <div className="col-md-6 hidden">
                    <span className="text-danger text-center fw-bolder">
                      Patient Details
                    </span>
                    <input
                      type="text"
                      className="form-control col-md-12 mb-1"
                      placeholder="id"
                      id="id"
                      defaultValue={patientData.id}
                      readOnly
                    />
                    <input
                      type="text"
                      className="form-control col-md-12 mb-1"
                      placeholder="patient_id"
                      id="patient_id"
                      defaultValue={patientData.patient_id}
                      readOnly
                    />
                    <input
                      type="text"
                      className="form-control col-md-12 mb-1"
                      placeholder="Customer Name"
                      id="customer_name"
                      defaultValue={patientData.names}
                      readOnly
                    />
                    <input
                      type="text"
                      className="form-control col-md-12 mb-1"
                      placeholder="Customer No"
                      id="customer_no"
                      defaultValue={patientData.mobile_no}
                      readOnly
                    />

                    <select
                      id="trans_type"
                      className="form-control col-md-12"
                      onChange={(e) => setSelectedTransType(e.target.value)}
                    >
                      {transactionType.map((dt) => {
                        return <option value={dt.code}>{dt.type}</option>;
                      })}
                    </select>
                    <input
                      type="text"
                      className="form-control col-md-12 ml-1"
                      placeholder="Mpesa code"
                      id="mpesa_code"
                      hidden={hidden}
                    />
                    <select
                      id="clinical_diagnosis"
                      className="form-control col-md-12"
                    >
                      {choosenClinicalDiagnosis.map((dt) => {
                        return dt;
                      })}
                    </select>
                  </div>
                </div>

                <div className={"row justify-content-center"}>
                  <Spinner />
                </div>
              </form>
            </div>
          </div>
        </div>
      {/*Message modal*/}
      <Modal5
        modalIsOpen={tableModal}
        closeModal={closeTableModal}
        // background="#0047AB"
        body={
          <div>
            <p className="text text-success font-weight-bold h1">
              Payment Summary
            </p>
            <table className="table table-bordered table-hover table-lg">
              <thead>
                <tr>
                  <th>ITEM</th>
                  <th>PRICE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ fontSize: "20px" }}>paid</td>
                  <td>
                    <input
                      id="paid"
                      type="number"
                      min={0}
                      className="form-control"
                      onInput={calcBalance}
                      style={{ fontSize: "20px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontSize: "20px" }}>Total</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      style={{ fontSize: "20px" }}
                      value={totals}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontSize: "20px", paddingLeft: "2px" }}>
                    Balance
                  </td>
                  <td
                    style={{
                      fontSize: "40px",
                      color: "green",
                      fontWeight: "bolder",
                    }}
                  >
                    {balance.toLocaleString()}
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <button
                disabled={balance < 0 ? true : false}
                className="btn btn-success btn-sm col-5"
                onClick={saveSale}
              >
                Pay
              </button>{" "}
              <button
                className="btn btn-danger btn-sm col-5"
                onClick={closeTableModal}
              >
                Close
              </button>
            </p>
          </div>
        }
      />
      {/*Response modal*/}
      <ResponseModal
        modalIsOpen={responseModal}
        closeModal={closeResponseModal}
        background="white"
        body={
          response !== "Sucessful" ? (
            <p className="text text-danger">{response}</p>
          ) : (
            <div className="text text-success h1">
              <i class="fas fa-check"></i> {response}
            </div>
          )
        }
      />
      <MessageModal
        modalIsOpen={messageModal}
        closeModal={closeMessageModal}
        background="white"
        body={<p className="text text-danger fw-bolder">{message}</p>}
      />
    </div>
  );
};

export default SalesMain;
